// extracted by mini-css-extract-plugin
export var aboveInput = "_jz-0";
export var actionButton = "_jz-5";
export var actionButtonContainer = "_jz-1";
export var actionIcon = "_jz-6";
export var aiInfoContainer = "_jz-2";
export var attachmentWrapper = "_jz-7";
export var bold = "_jz-3";
export var checkIcon = "_jz-8";
export var clickingRecipientBar = "_jz-11";
export var commentThreadSwitch = "_jz-a";
export var draftImage = "_jz-b";
export var draftImageContainer = "_jz-c";
export var draftImages = "_jz-e";
export var editButton = "_jz-g";
export var editor = "_jz-f";
export var editorContainer = "_jz-y";
export var editorErrorTooltipWrapper = "_jz-9";
export var headerDivider = "_jz-h";
export var icon = "_jz-i";
export var info = "_jz-j";
export var internal = "_jz-n";
export var internalDivider = "_jz-k";
export var internalMessage = "_jz-l";
export var messageInputCard = "_jz-m";
export var messageInputForm = "_jz-o";
export var messageInputFormInternal = "_jz-p";
export var options = "_jz-q";
export var publicMessageCustomer = "_jz-s";
export var publicMessageMerchant = "_jz-r";
export var removeImageButton = "_jz-d";
export var replyButtons = "_jz-t";
export var showSignatureButton = "_jz-u";
export var spinner = "_jz-v";
export var verticalButtonDivider = "_jz-4";
export var visibilitySelector = "_jz-w";
export var warning = "_jz-x";
export var wrappingText = "_jz-z";
export var writingInternalNoteTopBorder = "_jz-10";